/*
    Model grid: ( ---: hole)

    | 2 |         10        |
    | 2 |         10        |
    | 2 |         10        |
    | 2 |         10        |
    | 2 |         10        |
    | 2 |    5    |1|--3--|1|
    | 2 |----5----|1|--3--|1|
    | 2 |----5----|1|--3--|1|
    | 2 |----5----|1|--3--|1|
    | 2 |    5    |1|--3--|1|
    | 2 |         10        |
    | 2 |         10        |
    | 2 |         10        |
    | 2 |         10        |
    | 2 |         10        |
*/

export const PAYLOAD = {
  code: 'sidebar_holes_model',
  descr: 'Sidebar Holes Model',
  template: '<html></html>',
  configuration: {
    frames: [
      {
        descr: 'Zero',
        pos: 0,
        sketch: {
          x1: 0,
          x2: 1,
          y1: 0,
          y2: 14,
        },
      },
      {
        descr: 'One',
        pos: 1,
        sketch: {
          x1: 2,
          x2: 11,
          y1: 0,
          y2: 4,
        },
      },
      {
        descr: 'Two',
        pos: 2,
        sketch: {
          x1: 2,
          x2: 6,
          y1: 5,
          y2: 5,
        },
      },
      {
        descr: 'Three',
        pos: 3,
        sketch: {
          x1: 2,
          x2: 6,
          y1: 9,
          y2: 9,
        },
      },
      {
        descr: 'Four',
        pos: 4,
        sketch: {
          x1: 7,
          x2: 7,
          y1: 5,
          y2: 9,
        },
      },
      {
        descr: 'Five',
        pos: 5,
        sketch: {
          x1: 11,
          x2: 11,
          y1: 5,
          y2: 9,
        },
      },
      {
        descr: 'Six',
        pos: 6,
        sketch: {
          x1: 2,
          x2: 11,
          y1: 10,
          y2: 14,
        },
      },
    ],
  },
};


export const CELL_MAP = {
  'root:0-0/11-14': {
    x1: 0,
    x2: 11,
    y1: 0,
    y2: 14,
    type: 'root',
    key: 'root:0-0/11-14',
  },
  'col:0-0/1-14': {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 14,
    type: 'col',
    key: 'col:0-0/1-14',
    parentKey: 'row:0-0/11-14',
    framePos: 0,
    frameDescr: 'Zero',
    frameIsMainFrame: false,
  },
  'col:2-0/11-14': {
    x1: 2,
    x2: 11,
    y1: 0,
    y2: 14,
    type: 'col',
    key: 'col:2-0/11-14',
    parentKey: 'row:0-0/11-14',
  },
  'row:0-0/11-14': {
    x1: 0,
    x2: 11,
    y1: 0,
    y2: 14,
    type: 'row',
    key: 'row:0-0/11-14',
    parentKey: 'root:0-0/11-14',
  },
  'col:2-0/11-4': {
    x1: 2,
    x2: 11,
    y1: 0,
    y2: 4,
    type: 'col',
    key: 'col:2-0/11-4',
    parentKey: 'row:2-0/11-4',
    framePos: 1,
    frameDescr: 'One',
    frameIsMainFrame: false,
  },
  'col:2-5/6-9': {
    x1: 2,
    x2: 6,
    y1: 5,
    y2: 9,
    type: 'col',
    key: 'col:2-5/6-9',
    parentKey: 'row:2-5/11-9',
  },
  'col:7-5/7-9': {
    x1: 7,
    x2: 7,
    y1: 5,
    y2: 9,
    type: 'col',
    key: 'col:7-5/7-9',
    parentKey: 'row:2-5/11-9',
    framePos: 4,
    frameDescr: 'Four',
    frameIsMainFrame: false,
  },
  'col:8-5/8-9': {
    x1: 8,
    x2: 8,
    y1: 5,
    y2: 9,
    type: 'col',
    key: 'col:8-5/8-9',
    parentKey: 'row:2-5/11-9',
  },
  'col:9-5/9-9': {
    x1: 9,
    x2: 9,
    y1: 5,
    y2: 9,
    type: 'col',
    key: 'col:9-5/9-9',
    parentKey: 'row:2-5/11-9',
  },
  'col:10-5/10-9': {
    x1: 10,
    x2: 10,
    y1: 5,
    y2: 9,
    type: 'col',
    key: 'col:10-5/10-9',
    parentKey: 'row:2-5/11-9',
  },
  'col:11-5/11-9': {
    x1: 11,
    x2: 11,
    y1: 5,
    y2: 9,
    type: 'col',
    key: 'col:11-5/11-9',
    parentKey: 'row:2-5/11-9',
    framePos: 5,
    frameDescr: 'Five',
    frameIsMainFrame: false,
  },
  'col:2-10/11-14': {
    x1: 2,
    x2: 11,
    y1: 10,
    y2: 14,
    type: 'col',
    key: 'col:2-10/11-14',
    parentKey: 'row:2-10/11-14',
    framePos: 6,
    frameDescr: 'Six',
    frameIsMainFrame: false,
  },
  'row:2-0/11-4': {
    x1: 2,
    x2: 11,
    y1: 0,
    y2: 4,
    type: 'row',
    key: 'row:2-0/11-4',
    parentKey: 'col:2-0/11-14',
  },
  'row:2-5/11-9': {
    x1: 2,
    x2: 11,
    y1: 5,
    y2: 9,
    type: 'row',
    key: 'row:2-5/11-9',
    parentKey: 'col:2-0/11-14',
  },
  'row:2-10/11-14': {
    x1: 2,
    x2: 11,
    y1: 10,
    y2: 14,
    type: 'row',
    key: 'row:2-10/11-14',
    parentKey: 'col:2-0/11-14',
  },
  'col:10-5/10-5': {
    x1: 10,
    x2: 10,
    y1: 5,
    y2: 5,
    type: 'col',
    key: 'col:10-5/10-5',
    parentKey: 'row:10-5/10-5',
  },
  'col:10-6/10-6': {
    x1: 10,
    x2: 10,
    y1: 6,
    y2: 6,
    type: 'col',
    key: 'col:10-6/10-6',
    parentKey: 'row:10-6/10-6',
  },
  'col:10-7/10-7': {
    x1: 10,
    x2: 10,
    y1: 7,
    y2: 7,
    type: 'col',
    key: 'col:10-7/10-7',
    parentKey: 'row:10-7/10-7',
  },
  'col:10-8/10-8': {
    x1: 10,
    x2: 10,
    y1: 8,
    y2: 8,
    type: 'col',
    key: 'col:10-8/10-8',
    parentKey: 'row:10-8/10-8',
  },
  'col:10-9/10-9': {
    x1: 10,
    x2: 10,
    y1: 9,
    y2: 9,
    type: 'col',
    key: 'col:10-9/10-9',
    parentKey: 'row:10-9/10-9',
  },
  'row:10-5/10-5': {
    x1: 10,
    x2: 10,
    y1: 5,
    y2: 5,
    type: 'row',
    key: 'row:10-5/10-5',
    parentKey: 'col:10-5/10-9',
  },
  'row:10-6/10-6': {
    x1: 10,
    x2: 10,
    y1: 6,
    y2: 6,
    type: 'row',
    key: 'row:10-6/10-6',
    parentKey: 'col:10-5/10-9',
  },
  'row:10-7/10-7': {
    x1: 10,
    x2: 10,
    y1: 7,
    y2: 7,
    type: 'row',
    key: 'row:10-7/10-7',
    parentKey: 'col:10-5/10-9',
  },
  'row:10-8/10-8': {
    x1: 10,
    x2: 10,
    y1: 8,
    y2: 8,
    type: 'row',
    key: 'row:10-8/10-8',
    parentKey: 'col:10-5/10-9',
  },
  'row:10-9/10-9': {
    x1: 10,
    x2: 10,
    y1: 9,
    y2: 9,
    type: 'row',
    key: 'row:10-9/10-9',
    parentKey: 'col:10-5/10-9',
  },
  'col:9-5/9-5': {
    x1: 9,
    x2: 9,
    y1: 5,
    y2: 5,
    type: 'col',
    key: 'col:9-5/9-5',
    parentKey: 'row:9-5/9-5',
  },
  'col:9-6/9-6': {
    x1: 9,
    x2: 9,
    y1: 6,
    y2: 6,
    type: 'col',
    key: 'col:9-6/9-6',
    parentKey: 'row:9-6/9-6',
  },
  'col:9-7/9-7': {
    x1: 9,
    x2: 9,
    y1: 7,
    y2: 7,
    type: 'col',
    key: 'col:9-7/9-7',
    parentKey: 'row:9-7/9-7',
  },
  'col:9-8/9-8': {
    x1: 9,
    x2: 9,
    y1: 8,
    y2: 8,
    type: 'col',
    key: 'col:9-8/9-8',
    parentKey: 'row:9-8/9-8',
  },
  'col:9-9/9-9': {
    x1: 9,
    x2: 9,
    y1: 9,
    y2: 9,
    type: 'col',
    key: 'col:9-9/9-9',
    parentKey: 'row:9-9/9-9',
  },
  'row:9-5/9-5': {
    x1: 9,
    x2: 9,
    y1: 5,
    y2: 5,
    type: 'row',
    key: 'row:9-5/9-5',
    parentKey: 'col:9-5/9-9',
  },
  'row:9-6/9-6': {
    x1: 9,
    x2: 9,
    y1: 6,
    y2: 6,
    type: 'row',
    key: 'row:9-6/9-6',
    parentKey: 'col:9-5/9-9',
  },
  'row:9-7/9-7': {
    x1: 9,
    x2: 9,
    y1: 7,
    y2: 7,
    type: 'row',
    key: 'row:9-7/9-7',
    parentKey: 'col:9-5/9-9',
  },
  'row:9-8/9-8': {
    x1: 9,
    x2: 9,
    y1: 8,
    y2: 8,
    type: 'row',
    key: 'row:9-8/9-8',
    parentKey: 'col:9-5/9-9',
  },
  'row:9-9/9-9': {
    x1: 9,
    x2: 9,
    y1: 9,
    y2: 9,
    type: 'row',
    key: 'row:9-9/9-9',
    parentKey: 'col:9-5/9-9',
  },
  'col:8-5/8-5': {
    x1: 8,
    x2: 8,
    y1: 5,
    y2: 5,
    type: 'col',
    key: 'col:8-5/8-5',
    parentKey: 'row:8-5/8-5',
  },
  'col:8-6/8-6': {
    x1: 8,
    x2: 8,
    y1: 6,
    y2: 6,
    type: 'col',
    key: 'col:8-6/8-6',
    parentKey: 'row:8-6/8-6',
  },
  'col:8-7/8-7': {
    x1: 8,
    x2: 8,
    y1: 7,
    y2: 7,
    type: 'col',
    key: 'col:8-7/8-7',
    parentKey: 'row:8-7/8-7',
  },
  'col:8-8/8-8': {
    x1: 8,
    x2: 8,
    y1: 8,
    y2: 8,
    type: 'col',
    key: 'col:8-8/8-8',
    parentKey: 'row:8-8/8-8',
  },
  'col:8-9/8-9': {
    x1: 8,
    x2: 8,
    y1: 9,
    y2: 9,
    type: 'col',
    key: 'col:8-9/8-9',
    parentKey: 'row:8-9/8-9',
  },
  'row:8-5/8-5': {
    x1: 8,
    x2: 8,
    y1: 5,
    y2: 5,
    type: 'row',
    key: 'row:8-5/8-5',
    parentKey: 'col:8-5/8-9',
  },
  'row:8-6/8-6': {
    x1: 8,
    x2: 8,
    y1: 6,
    y2: 6,
    type: 'row',
    key: 'row:8-6/8-6',
    parentKey: 'col:8-5/8-9',
  },
  'row:8-7/8-7': {
    x1: 8,
    x2: 8,
    y1: 7,
    y2: 7,
    type: 'row',
    key: 'row:8-7/8-7',
    parentKey: 'col:8-5/8-9',
  },
  'row:8-8/8-8': {
    x1: 8,
    x2: 8,
    y1: 8,
    y2: 8,
    type: 'row',
    key: 'row:8-8/8-8',
    parentKey: 'col:8-5/8-9',
  },
  'row:8-9/8-9': {
    x1: 8,
    x2: 8,
    y1: 9,
    y2: 9,
    type: 'row',
    key: 'row:8-9/8-9',
    parentKey: 'col:8-5/8-9',
  },
  'col:2-5/6-5': {
    x1: 2,
    x2: 6,
    y1: 5,
    y2: 5,
    type: 'col',
    key: 'col:2-5/6-5',
    parentKey: 'row:2-5/6-5',
    framePos: 2,
    frameDescr: 'Two',
    frameIsMainFrame: false,
  },
  'col:2-6/2-6': {
    x1: 2,
    x2: 2,
    y1: 6,
    y2: 6,
    type: 'col',
    key: 'col:2-6/2-6',
    parentKey: 'row:2-6/6-6',
  },
  'col:3-6/3-6': {
    x1: 3,
    x2: 3,
    y1: 6,
    y2: 6,
    type: 'col',
    key: 'col:3-6/3-6',
    parentKey: 'row:2-6/6-6',
  },
  'col:4-6/4-6': {
    x1: 4,
    x2: 4,
    y1: 6,
    y2: 6,
    type: 'col',
    key: 'col:4-6/4-6',
    parentKey: 'row:2-6/6-6',
  },
  'col:5-6/5-6': {
    x1: 5,
    x2: 5,
    y1: 6,
    y2: 6,
    type: 'col',
    key: 'col:5-6/5-6',
    parentKey: 'row:2-6/6-6',
  },
  'col:6-6/6-6': {
    x1: 6,
    x2: 6,
    y1: 6,
    y2: 6,
    type: 'col',
    key: 'col:6-6/6-6',
    parentKey: 'row:2-6/6-6',
  },
  'col:2-7/2-7': {
    x1: 2,
    x2: 2,
    y1: 7,
    y2: 7,
    type: 'col',
    key: 'col:2-7/2-7',
    parentKey: 'row:2-7/6-7',
  },
  'col:3-7/3-7': {
    x1: 3,
    x2: 3,
    y1: 7,
    y2: 7,
    type: 'col',
    key: 'col:3-7/3-7',
    parentKey: 'row:2-7/6-7',
  },
  'col:4-7/4-7': {
    x1: 4,
    x2: 4,
    y1: 7,
    y2: 7,
    type: 'col',
    key: 'col:4-7/4-7',
    parentKey: 'row:2-7/6-7',
  },
  'col:5-7/5-7': {
    x1: 5,
    x2: 5,
    y1: 7,
    y2: 7,
    type: 'col',
    key: 'col:5-7/5-7',
    parentKey: 'row:2-7/6-7',
  },
  'col:6-7/6-7': {
    x1: 6,
    x2: 6,
    y1: 7,
    y2: 7,
    type: 'col',
    key: 'col:6-7/6-7',
    parentKey: 'row:2-7/6-7',
  },
  'col:2-8/2-8': {
    x1: 2,
    x2: 2,
    y1: 8,
    y2: 8,
    type: 'col',
    key: 'col:2-8/2-8',
    parentKey: 'row:2-8/6-8',
  },
  'col:3-8/3-8': {
    x1: 3,
    x2: 3,
    y1: 8,
    y2: 8,
    type: 'col',
    key: 'col:3-8/3-8',
    parentKey: 'row:2-8/6-8',
  },
  'col:4-8/4-8': {
    x1: 4,
    x2: 4,
    y1: 8,
    y2: 8,
    type: 'col',
    key: 'col:4-8/4-8',
    parentKey: 'row:2-8/6-8',
  },
  'col:5-8/5-8': {
    x1: 5,
    x2: 5,
    y1: 8,
    y2: 8,
    type: 'col',
    key: 'col:5-8/5-8',
    parentKey: 'row:2-8/6-8',
  },
  'col:6-8/6-8': {
    x1: 6,
    x2: 6,
    y1: 8,
    y2: 8,
    type: 'col',
    key: 'col:6-8/6-8',
    parentKey: 'row:2-8/6-8',
  },
  'col:2-9/6-9': {
    x1: 2,
    x2: 6,
    y1: 9,
    y2: 9,
    type: 'col',
    key: 'col:2-9/6-9',
    parentKey: 'row:2-9/6-9',
    framePos: 3,
    frameDescr: 'Three',
    frameIsMainFrame: false,
  },
  'row:2-5/6-5': {
    x1: 2,
    x2: 6,
    y1: 5,
    y2: 5,
    type: 'row',
    key: 'row:2-5/6-5',
    parentKey: 'col:2-5/6-9',
  },
  'row:2-6/6-6': {
    x1: 2,
    x2: 6,
    y1: 6,
    y2: 6,
    type: 'row',
    key: 'row:2-6/6-6',
    parentKey: 'col:2-5/6-9',
  },
  'row:2-7/6-7': {
    x1: 2,
    x2: 6,
    y1: 7,
    y2: 7,
    type: 'row',
    key: 'row:2-7/6-7',
    parentKey: 'col:2-5/6-9',
  },
  'row:2-8/6-8': {
    x1: 2,
    x2: 6,
    y1: 8,
    y2: 8,
    type: 'row',
    key: 'row:2-8/6-8',
    parentKey: 'col:2-5/6-9',
  },
  'row:2-9/6-9': {
    x1: 2,
    x2: 6,
    y1: 9,
    y2: 9,
    type: 'row',
    key: 'row:2-9/6-9',
    parentKey: 'col:2-5/6-9',
  },
};
